import { Colors } from 'libs/ui/theme';

import { SvgIcon } from '../SvgIcon';
import { SvgProps } from '../types';

export const Time = ({
  size = 24,
  color = Colors.black,
  className,
}: SvgProps) => (
  <SvgIcon className={className} size={size}>
    <svg
      color={color}
      fill="none"
      height="17"
      viewBox="0 0 16 17"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00073 6.33594V9.0026L9.15535 9.66927M1.33398 9.0026C1.33398 12.6845 4.31875 15.6693 8.00065 15.6693C11.6825 15.6693 14.6673 12.6845 14.6673 9.0026C14.6673 5.32071 11.6825 2.33594 8.00065 2.33594"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path
        d="M8.66732 1L8.04109 1.62623C7.65057 2.01675 7.65057 2.64992 8.04109 3.04044L8.66732 3.66667"
        stroke="currentColor"
        strokeLinecap="round"
      />
    </svg>
  </SvgIcon>
);
